import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
// import i18n (needs to be bundled ;))
import './i18n';
import { ErrorBoundaryContext } from 'react-use-error-boundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
//We use the useErrorBoundary hook to dispaly errors since react 18 still does not support error
//boundaries with hooks. The top most app is wrapped with ErrorBoundaryContext to avoid wrapping
//every single component with "withErrorBoundary".
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
